var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeycapabilities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#EDFAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 16.6666C21.3332 20 18.9998 21.6666 16.2265 22.6333C16.0813 22.6825 15.9235 22.6802 15.7798 22.6266C12.9998 21.6666 10.6665 20 10.6665 16.6666V12C10.6665 11.8232 10.7367 11.6536 10.8618 11.5286C10.9868 11.4035 11.1564 11.3333 11.3332 11.3333C12.6665 11.3333 14.3332 10.5333 15.4932 9.51997C15.6344 9.39931 15.8141 9.33301 15.9998 9.33301C16.1856 9.33301 16.3653 9.39931 16.5065 9.51997C17.6732 10.54 19.3332 11.3333 20.6665 11.3333C20.8433 11.3333 21.0129 11.4035 21.1379 11.5286C21.2629 11.6536 21.3332 11.8232 21.3332 12V16.6666Z",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L15.3333 17.3333L18 14.6666",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycapabilities);
export default __webpack_public_path__ + "static/media/keycapabilities.bb75293f6cb33e3a85dffabb7db1337a.svg";
export { ForwardRef as ReactComponent };